/*import $ from 'jquery'

const $block = $('.testimonials-video-block')

const el = $block.find('.youtube-video-iframe')
const ytId = el.attr('data-id')
const testimonialsModal = document.getElementById('testimonials-modal')

testimonialsModal.addEventListener('show.bs.modal', function () {


  el.replaceWith(
    `<iframe src="https://www.youtube-nocookie.com/embed/${ytId}?autoplay=1" allow="autoplay">`
  )
})*/

document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('testimonials-modal')
  if (modal) {
    var videoWrapper = modal.querySelector('.testimonials-video-block__video-wrapper')
    modal.addEventListener('show.bs.modal', function(event) {
      var button = event.relatedTarget // Le bouton qui a déclenché l'ouverture de la modal
      var videoCode = button.getAttribute('data-video-code')

      if (videoCode) {
        // Charger l'iframe dans le wrapper
        videoWrapper.innerHTML = videoCode
      } else {
        videoWrapper.innerHTML = 'No video URL found.'
      }
    })

    modal.addEventListener('hide.bs.modal', function() {
      // Nettoyer le contenu de la modal lors de sa fermeture
      videoWrapper.innerHTML = ''
    })
  }

})

